import missionWizardImage from '../../../../ui/assets/missionWizardImage.svg';
import { useMissionsTranslation } from '../../../../ui/hooks';
import { FullScreenWizard } from '@juvare/common-form-ui/FullScreenWizard';
import { showConfirmDialog } from '@juvare/common-web-ui/DialogHelper';
import { NavigationContext } from '@juvare/common-web-ui/NavigationContext';
import { Typography } from '@mui/material';
import React from 'react';
import { useNavigate, useParams } from 'react-router';
import { useDuplicateShift } from '../hooks/useDuplicateShift';
import { useShift } from '../hooks/useShift';
export const DuplicateShift = () => {
    const { t } = useMissionsTranslation();
    const [changed, setChanged] = React.useState(false);
    const navigationContext = React.useContext(NavigationContext);
    const navigate = useNavigate();
    const { missionId, shiftId } = useParams();
    const { shift, isLoading, isValidating } = useShift(shiftId);
    const handleNavigateBack = () => navigationContext.navigate(() => navigate(-1));
    const handleCancel = () => {
        if (changed) {
            showConfirmDialog({
                title: t('wizard.confirmWizardCloseTitle'),
                confirmLabel: t('wizard.closeWizardConfirmLabel'),
                cancelLabel: t('wizard.closeWizardCancelLabel'),
                content: React.createElement(Typography, { variant: 'body1' }, wizardConfig.closeWizardContent),
                onConfirm: () => {
                    navigationContext.clearChanged();
                    handleNavigateBack();
                },
            });
        }
        else {
            navigationContext.navigate(() => handleNavigateBack());
        }
    };
    const handleChanged = React.useCallback((changed) => {
        if (changed) {
            navigationContext.setChanged(t('wizard.confirmWizardCloseTitle'));
        }
        else {
            navigationContext.clearChanged();
        }
        setChanged(changed);
    }, [t, navigationContext]);
    const handleSubmitSuccess = () => {
        navigationContext.clearChanged();
        handleNavigateBack();
    };
    const { wizardConfig } = useDuplicateShift({
        missionId,
        shiftData: shift === null || shift === void 0 ? void 0 : shift.data,
        duplicatedShiftId: shiftId,
    });
    if (!shift || isLoading || isValidating) {
        return React.createElement("div", null, t('common.loading'));
    }
    return (React.createElement(FullScreenWizard, { open: true, image: { src: missionWizardImage, alt: 'Duplicate Shift' }, title: wizardConfig.title, data: wizardConfig.data, steps: wizardConfig.steps, onCancel: handleCancel, onChanged: handleChanged, onSubmit: wizardConfig.onSubmit, onSubmitSuccess: handleSubmitSuccess }));
};
